import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../base/LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img 
                className="h-8 w-auto" 
                src="img/gpax.png" 
                alt="GPAX" 
              />
            </div>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#home" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
              {t('nav.home')}
            </a>
            <a href="#features" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
              {t('nav.features')}
            </a>
            <a href="#benefits" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
              {t('nav.benefits')}
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
              {t('nav.contact')}
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <LanguageSwitcher />
            <a 
              href="#contact" 
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.contact')}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}